import { Tabs } from 'antd';
import MatchandMerge from './match&merge/MatchandMerge';
import Issues from './match&merge/Issues';

export default function MatchTab({ nodeId, entityId, attributes, matchRulesData, setMatchRulesData  }) {
  const onChange = (key) => {
    console.log('Active Tab:', key);
  };

  const items = [
    {
      label: 'Rules',
      key: '1',
      children: <MatchandMerge entityId={entityId} attributes={attributes} matchRulesData={matchRulesData} setMatchRulesData={setMatchRulesData} />,
    },
    {
      label: 'Issues & Resolve',
      key: '2',
      children: <Issues nodeId={nodeId} />,
    },
  ];

  return <Tabs type="card" onChange={onChange} items={items} />;
}
